var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.9192 63.8383C49.5476 63.8383 63.8383 49.5476 63.8383 31.9192C63.8383 14.2907 49.5476 0 31.9192 0C14.2907 0 0 14.2907 0 31.9192C0 49.5476 14.2907 63.8383 31.9192 63.8383Z",
    fill: "#ED3125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.4696 50.3045C41.0603 50.3045 49.5863 37.3902 49.5863 26.1878C49.5863 25.8189 49.5768 25.4548 49.5626 25.0907C51.2177 23.8943 52.6552 22.4 53.7901 20.7024C52.2722 21.3786 50.636 21.8326 48.9242 22.0359C50.6739 20.9861 52.0168 19.3263 52.6505 17.3497C51.0143 18.3191 49.1985 19.0284 47.2692 19.4067C45.7229 17.7611 43.5193 16.7302 41.0839 16.7302C36.4025 16.7302 32.6053 20.5274 32.6053 25.2042C32.6053 25.8709 32.6809 26.514 32.8275 27.1382C25.7817 26.7836 19.535 23.412 15.3595 18.2813C14.6312 19.5344 14.2104 20.9908 14.2104 22.5419C14.2104 25.4832 15.7047 28.0793 17.9839 29.5972C16.5937 29.5546 15.2885 29.1716 14.1442 28.5379C14.1442 28.5711 14.1442 28.6089 14.1442 28.6467C14.1442 32.7513 17.0665 36.1796 20.9441 36.9552C20.2301 37.149 19.4829 37.2531 18.7122 37.2531C18.1684 37.2531 17.634 37.201 17.1186 37.1017C18.1967 40.4686 21.3272 42.9181 25.0345 42.9891C22.1311 45.2636 18.4804 46.616 14.5083 46.616C13.8226 46.616 13.1511 46.5782 12.4844 46.4978C16.2296 48.9 20.6841 50.3045 25.4696 50.3045Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.642a36d29bbe7dc6f4ec4a5d251170c0.svg";
export { ForwardRef as ReactComponent };